import { useEffect, useState } from 'react';
import devLogger from 'react-utils/devLogger';
// eslint-disable-next-line no-restricted-imports
import userInfo, { userInfoSync, UserInfo } from 'hub-http/userInfo';

/*
 * Copied from customer-data-properties. This can be replaced when this lib is quartz exclusive.
 */

export const useUserInfo = () => {
  const [userInfoResponse, setUserInfoResponse] = useState<
    UserInfo | undefined
  >(() => {
    // initialize with userInfoSync in case userInfo has already been loaded.
    // this avoids an initial render without gates/scopes, if possible.
    // userInfoSync throws an Error if userInfo has not finished loading yet;
    // in that case fall back to waiting for async userInfo
    try {
      return userInfoSync();
    } catch (__error) {
      devLogger.warn({
        message: `ui-product-approvals-userinfosync: Failure reading userinfo sync`,
        key: 'ui-product-approvals-userinfosync',
      });
    }
    return undefined;
  });

  useEffect(() => {
    if (userInfoResponse) {
      return;
    }

    try {
      userInfo({ ignoreRedirect: true })
        .then((response) => {
          setUserInfoResponse(response);
        })
        .catch(() => {
          devLogger.warn({
            message: `ui-product-approvals-userinfo: API failure fetching userinfo`,
            key: 'ui-product-approvals-userinfo-api',
          });
        });
    } catch (err) {
      devLogger.warn({
        message: `ui-product-approvals-userinfo: Failure fetching userinfo`,
        key: 'ui-product-approvals-userinfo-api',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return userInfoResponse;
};
